"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../Icons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConditionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? wrapper(children) : children;
};
const Input = _ref2 => {
  let {
    className,
    value,
    disabled = false,
    size = 'medium',
    onChange: _onChange,
    placeholder,
    style,
    autoFocus = false,
    forwardRef,
    icon,
    cmk = false,
    isTextArea = false,
    rows = 3,
    type = 'text',
    maxLength = '256',
    required = false,
    autocomplete = 'off',
    min,
    max
  } = _ref2;
  const [stateType, setType] = _react.default.useState(type);
  if (!icon) return /*#__PURE__*/_react.default.createElement(ConditionalWrapper, {
    condition: type === 'password',
    wrapper: children => /*#__PURE__*/_react.default.createElement("span", {
      className: "hpd-input-icon hpd-input-icon-right"
    }, children)
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isTextArea && /*#__PURE__*/_react.default.createElement("input", {
    type: stateType,
    ref: forwardRef,
    className: size + ' hpd ' + className,
    maxLength: maxLength,
    required: required,
    autoComplete: autocomplete,
    style: style,
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    onChange: e => _onChange(e.target.value),
    autoFocus: autoFocus,
    min: min,
    max: max
  }), isTextArea && /*#__PURE__*/_react.default.createElement("textarea", {
    ref: forwardRef,
    className: size + ' hpd ' + className,
    style: style,
    type: "text",
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    onChange: e => _onChange(e.target.value),
    autoFocus: autoFocus,
    rows: rows
  }), type === 'password' && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex hpd-input-icon-right-wrapper align-items-center justify-content-center hoverable hover-bg-light br-6px",
    onClick: () => setType(stateType === 'password' ? 'text' : 'password'),
    style: {
      minWidth: '25px',
      minHeight: '25px'
    }
  }, stateType === 'password' && /*#__PURE__*/_react.default.createElement(_Icons.default, {
    size: "large",
    name: "eye"
  }), stateType === 'text' && /*#__PURE__*/_react.default.createElement(_Icons.default, {
    size: "large",
    name: "eyeoff"
  }))));
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-input-icon"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: icon
  }), !isTextArea && /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    ref: forwardRef,
    className: size + ' hpd ' + className,
    maxLength: maxLength,
    required: required,
    autoComplete: autocomplete,
    style: style,
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    onChange: e => _onChange(e.target.value),
    autoFocus: autoFocus
  }), cmk && /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-cmk-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-cmk"
  }, "\u2318"), /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-cmk"
  }, "K")));
};
var _default = exports.default = Input;